module.exports = __webpack_public_path__ + "img/Square-Logo.0f0526d0.png";